import { onBeforeUnmount, ref, watch } from 'vue'

/**
 * 把滚动容器上的垂直滚轮转成水平滚动。
 * 到达水平边界后不再拦截，让外层页面继续垂直滚动。
 * 触控板水平双指滑动（带 deltaX）和 shift+wheel 不拦截，保留浏览器原生行为。
 */
export function useWheelToHorizontalScroll() {
  const scrollRef = ref(null)
  let el = null

  function onWheel(e) {
    if (!el) return
    if (e.shiftKey) return
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return

    const canScrollX = el.scrollWidth - el.clientWidth > 1
    if (!canScrollX) return

    const maxScroll = el.scrollWidth - el.clientWidth
    const atStart = el.scrollLeft <= 0
    const atEnd = el.scrollLeft >= maxScroll - 1

    const delta = e.deltaY
    if ((delta > 0 && !atEnd) || (delta < 0 && !atStart)) {
      e.preventDefault()
      el.scrollLeft += delta
    }
  }

  function bindScrollElement(nextEl) {
    if (el === nextEl) return
    if (el) {
      el.removeEventListener('wheel', onWheel)
    }
    el = nextEl
    if (el) {
      el.addEventListener('wheel', onWheel, { passive: false })
    }
  }

  watch(scrollRef, nextEl => {
    bindScrollElement(nextEl)
  }, { flush: 'post' })

  onBeforeUnmount(() => {
    bindScrollElement(null)
  })

  return scrollRef
}
